import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

// Mock MapView component for web
export const MapView = ({ children, style, ...props }) => (
  <View style={[styles.mapContainer, style]}>
    <Text style={styles.mapText}>Map View (Web Demo)</Text>
    <Text style={styles.mapSubtext}>Maps are displayed in the native mobile app</Text>
    {children}
  </View>
);

// Mock Marker component
export const Marker = ({ coordinate, title, description }) => (
  <View style={styles.marker}>
    <Text style={styles.markerText}>
      📍 {title || 'Marker'}
    </Text>
  </View>
);

// Mock Polyline component
export const Polyline = () => null;

// Mock Circle component
export const Circle = () => null;

// Mock default export
export default MapView;

const styles = StyleSheet.create({
  mapContainer: {
    width: '100%',
    height: '100%',
    backgroundColor: '#e8e8e8',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#ccc',
  },
  mapText: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 8,
  },
  mapSubtext: {
    fontSize: 14,
    color: '#666',
    textAlign: 'center',
    paddingHorizontal: 20,
  },
  marker: {
    padding: 4,
    backgroundColor: '#fff',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#333',
  },
  markerText: {
    fontSize: 12,
  },
});

